<template>
  <!-- 支付宝购买商品 -->
  <div>
  </div>
</template>

<script>

export default {
  created() {
    this.aliBuy()
  },
  data() {
    return {
      payGateWay: ''
    }
  },
  methods: {
    async aliBuy() {
      const queryObj = {
        menuNumber: this.$route.query.menuNumber,
      }
      let formData = new FormData()
      formData.append('menuNumber', queryObj.menuNumber)
      formData.append('returnUrl', 'https://www.yunshangzg.com/userIndex')



      const res = await this.$axios.post('/pay/payMemberAli', formData)
      this.payGateWay = res.data
      //  res.data默认是我们拿到的form代码
      const div = document.createElement('div')
      div.innerHTML = res.data
      document.body.appendChild(div)
      document.forms[0].submit() //重要，这个才是点击跳页面的核心
    }
  },
  mounted() {


  },
  computed: {},
  watch: {},
  filters: {},
  components: {}
}
</script>

<style scoped lang='scss' scope>
.iframe {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/vip/payAli.vue